<template>
<standard-dialog v-model="visible" :width="1280" scrollable persistent>

  <template slot="title">
    <span class="title">{{ item.targetName || item.name }}</span>
  </template>

  <meter-chart :training="training" :validation="validation" :prediction="prediction" v-if="rawData"></meter-chart>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn flat color="primary" :loading="trainingRun" :disabled="!canTrain" @click="train">{{ $t('prediction.prediction')}}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import MeterPredictionChart from './MeterPredictionChart'
import LSTM from '@/components/utils/MeterLSTM'

export default {
  name: 'MeterPrediction',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    'standard-dialog': Dialog,
    'meter-chart': MeterPredictionChart
  },
  data() {
    return {
      functypes: [22, 29],
      rawData: null,
      training: [],
      validation: [],
      prediction: [],
      trainingRun: false,
    }
  },
  watch: {
    rawData(val) {
      let data = JSON.parse((val || {}).result || '[]');
      this.training = data.map(d => ({
        t: d[0],
        y: d[1] / 100
      }));
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) this.unbind();
        this.$emit('input', val);
      }
    },
    canTrain() {
      return this.training.length > 30;
    }
  },
  methods: {
    bind() {
      let [mac, uid, cid] = this.item.key.split('-');
      let ref = this.$db.ref('macJuice').child(mac).child(`${this.item.key}-meter`);
      this.$bindAsObject('rawData', ref, null, function() {
        let now = new Date().getTime();
        let t = ((this.rawData || {}).timestamp || [])[0] || 0;
        if (now - t > 5 * 60 * 1000)
          this.refresh(this.item.key);
      });
    },
    unbind() {
      let [mac, uid, cid] = this.item.key.split('-');
      let ref = this.$db.ref('macJuice').child(mac).child(`${this.item.key}-meter`);
      this.$unbind('rawData', ref);
    },
    refresh(key) {
      let [mac, uid, cid] = key.split('-');
      this.$db.ref('command/juice').push().set({
        deviceChart: true,
        user: this.userId,
        mac: mac,
        uid: uid,
        cid: cid,
        eventCode: 4804,
        juice: 'meter',
        days: 14
      });
    },
    train() {
      this.validation = [];
      this.trainingRun = true;
      setTimeout(() => {
        let data = this.training.map((t) => [t.t, t.y]);
        let result = LSTM(data);
        if (result) {
          //this.validation = result.validationY;
          this.prediction = result.predictY;
        }
        this.trainingRun = false;
      }, 300);
    }
  },
  mounted() {
    this.bind();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/juice/MeterPredictionDialog.vue